import React, { useState } from 'react';
import { Container, Typography, Button, Alert } from '@mui/material';
import { useCart } from '../CartContext';
import { useNavigate } from 'react-router-dom';
import { postJSON } from '../api';
import api from '../api';

export default function Payment() {
  const { cartItems, orderType, clearCart } = useCart();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  const subtotal = cartItems.reduce((sum, item) => {
    const upcharge = item.glutenFreeOption ? 1 : 0;
    return sum + (item.price + upcharge) * item.quantity;
  }, 0);

  const tax = orderType === 'Dine-In' ? parseFloat((subtotal * 0.08).toFixed(2)) : 0;
  const total = parseFloat((subtotal + tax).toFixed(2));

  async function handlePayWithClover() {
    try {
      setErr('');
      setLoading(true);

      const orderItems = cartItems.map(i => ({
        name: i.name,
        price: i.price,
        quantity: i.quantity,
        note: i.note || '',
        glutenFreeOption: !!i.glutenFreeOption
      }));

      const email = localStorage.getItem('userEmail') || '';

      // keep the order so we can write it after the user returns from Clover
      const pendingOrder = { items: orderItems, orderType, subtotal, tax, total, userEmail: email };
      sessionStorage.setItem('pendingOrder', JSON.stringify(pendingOrder));

      // ask backend for clover hosted checkout url
      const { href } = await postJSON('/payments/create-checkout', {
        items: orderItems,
        orderType,
        userEmail: email
      });

      window.location.assign(href);
    } catch (e) {
      console.error(e);
      setErr('Could not start payment. Please try again.');
      setLoading(false);
    }
  }

  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>Secure Payment</Typography>

      <Typography sx={{ mb: 2, whiteSpace: 'pre-line' }}>
        Subtotal: ${subtotal.toFixed(2)}{'\n'}
        Tax: ${tax.toFixed(2)}{'\n'}
        <strong>Total: ${total.toFixed(2)}</strong>
      </Typography>

      {err && <Alert severity="error" sx={{ mb: 2 }}>{err}</Alert>}

      <Button
        variant="contained"
        fullWidth
        onClick={handlePayWithClover}
        disabled={loading || cartItems.length === 0}
      >
        {loading ? 'Redirecting to Clover…' : 'Pay with Clover'}
      </Button>

      <Typography sx={{ mt: 2 }}>
        You will be redirected to Clover hosted checkout. After payment you will return here.
      </Typography>
    </Container>
  );
}
